import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";

const COLORS = {
  slate: "bg-slate-300 border-slate-500 text-slate-700",
  blue: "bg-blue-300 border-cyan-500 text-cyan-700",
  sky: "bg-sky-200 border-sky-500 text-sky-700",
  yellow: "bg-orange-300 border-orange-500 text-orange-700",
  amber: "bg-amber-200 text-amber-600 text-amber-700",
  lime: "bg-lime-200 border-lime-500 text-lime-700",
  indigo: "bg-violet-300 border-violet-500 text-violet-700",
  pink: "bg-pink-300 border-pink-500 text-pink-700",
  rose: "bg-rose-200 border-rose-500 text-rose-700",
  gray: "bg-gray-300 border-gray-500 text-gray-700",
  stone: "bg-stone-300 border-stone-500 text-stone-700",
  neutral: "bg-neutral-300 border-neutral-500 text-neutral-700",
  black: "bg-neutral-700 border-neutral-800 text-neutral-100",
};

const styleBase =
  "lg:py-2 tablet:p-3 md:p-0 md:w-20 lg:w-28 rounded-xl text-xs text-center uppercase";

function TableState({ states, storeId, model }) {
  const activeState = useSignal(null);

  const { reload } = useTable();
  if (!states) return null;

  async function ClickState(state) {
    activeState.value = activeState.value === state ? null : state;
    const domain = activeState.value ? [["state", "=", activeState.value]] : [];
    await reload(storeId, domain);
    // console.log("TableState ClickState", domain);
  }

  return (
    <div className="flex flex-wrap gap-2 my-4 md:text-sm">
      {Object.entries(states).map(([state, color]) => (
        <button
          type="button"
          key={state}
          className={cn(
            styleBase,
            COLORS[color || "slate"],
            activeState.value === state &&
              "ring-2 ring-inset active:scale-95 inline",
          )}
          onClick={() => ClickState(state)}
        >
          <FM id={`${model}.${state}`} />
        </button>
      ))}
    </div>
  );
}

export default TableState;
